<template>
  <div class="northwestern" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header">{{ organizationDetails.programName }}</h1>
      <h2 class="local-hero-subtitle">Recipient Home</h2>
    </div>

    <div class="form-container">
      <template v-if="loading">
        <LoadSpinner />
      </template>
      <template v-else>
        <div v-if="!showPaypalModal || payPalUpdated" class="card-shape status-message success-message">
          <div class="success-circle-check-icon">
            <img src="@/assets/icons/success-circle-check-icon.png" />
          </div>
          <div>
            <h4 v-translate>Payment Information Receieved!</h4>
            <p v-translate>
              We have received your PayPal account information, if you are approved you will receive a payout.
            </p>
          </div>
        </div>
      </template>
    </div>

    <Modal
      v-if="showPaypalModal && !payPalUpdated"
      dimmed
      :additionalModalStyles="{
        'max-width': '500px',
        border: 'none',
        padding: 0,
        overflow: 'hidden scroll',
      }"
      :additionalContainerStyles="{
        zIndex: '1001',
        padding: 0,
      }"
      :width="95"
    >
      <div class="form-container card-shape modal-window" style="overflow: hidden;">
        <h2 class="form-field-header" v-translate>We need some more information:</h2>
        <div class="form-field" style="margin-bottom: 0;">
          <p v-translate>We need your PayPal email address in order to complete your payout.</p>
        </div>
        <div class="form-footer">
          <div class="button-container" style="justify-content: center;">
            <button
              class="form-button"
              @click="goToPayPal"
            >
              <LoadSpinner v-if="loading" color="white"/>
              <span v-else v-translate>Add PayPal Email</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <!-- Required post-registration onboarding surveys -->
    <RequiredOnboardingSurveysModal :show="requiredOnboardingSurveysModal && !showPaypalModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import Modal from '@/components/Modal'

import Employee from '@/services/employees'

import RequiredOnboardingSurveysModal from '@/views/common/RequiredOnboardingSurveysModal'

export default {
  name: 'NorthwesternNomineeHome',
  components: {
    LoadSpinner,
    Modal,
    RequiredOnboardingSurveysModal,
  },
  data() {
    return {
      loading: true,
      showSuccessMessage: false,
      payPalUpdated: false,
      interval: null,
    }
  },
  async mounted() {
    this.interval = setInterval(this.updateUser, 2000)
    this.loading = false
  },
  methods: {
    async updateUser() {
      if(!this.user)
        return

      const employee = await Employee.api.retrieve(this.user.id)
      if(employee.paypalEmail) {
        this.payPalUpdated = true
        clearInterval(this.interval)
        this.interval = null
      }
    },
    goToPayPal(e) {
      this.$router.push({name: 'NomineeOnboardingPaymentDetails'})
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
    showPaypalModal() {
      return this.user && !this.user.paypalEmail
    },
    requiredOnboardingSurveysModal() {
      if(!this.user)
        return false

      if(this.user.isStaff || this.user.isAdmin || this.user.isThirdParty)
        return false

      return !this.user.hasCompletedRequiredOnboardingSurveys
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/responsive';

.northwestern {
  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-shape {
    padding: 2.5rem 1.5rem;
  }

  .status-message {
    display: flex;
    margin-bottom: 1rem;
    width: 80%;

    &.success-message {
      flex-direction: row;
      background-color: #d2f7dc;
    }

    &.failure-message {
      flex-direction: row;
      background-color: #f0d1d4;
    }

    .success-circle-check-icon, .failure-circle-x-icon {
      width: 20px;
      margin-right: 1rem;
      margin-top: 6px;
    }
  }

  .modal-window {
    margin-top: 4rem;
    padding: 2rem 3rem;
  }

  .modal-window-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 2rem;
  }

  .form-button {
    border: 2px solid transparent;
  }

  .form-button:hover {
    border: 2px solid var(--light-brand-color);
  }

  .wide-button {
    padding: 2rem;
    width: 80%;
  }
}
</style>
